import {
  QueryClient,
  QueryClientProvider,
  useQuery,
} from '@tanstack/react-query';
import axios from 'axios';
import { config } from './config/env';

const queryClient = new QueryClient();
const BUILD_TIME = new Date().toISOString();

// Test GitHub Actions deployment with preview

// Test deployment with new CLOUDFLARE_PAGES_TOKEN

function HealthCheck() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['health'],
    queryFn: async () => {
      const response = await axios.get(`${config.apiUrl}/health`);
      return response.data;
    },
  });

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <h2 className="text-xl font-semibold">API Health Status</h2>
        <span
          className={`px-2 py-1 text-sm rounded-full ${
            data?.status === 'healthy'
              ? 'bg-green-100 text-green-800'
              : 'bg-red-100 text-red-800'
          }`}
        >
          {data?.status || 'Unknown'}
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-gray-50 p-4 rounded-lg">
          <h3 className="font-medium text-gray-700 mb-2">Database</h3>
          <p
            className={`text-sm ${
              data?.database === 'connected' ? 'text-green-600' : 'text-red-600'
            }`}
          >
            {data?.database || 'Unknown'}
          </p>
        </div>

        {data?.sample_data && (
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="font-medium text-gray-700 mb-2">Sample Exercises</h3>
            <p className="text-sm text-gray-600">
              {data.sample_data.exercises_count} exercises loaded
            </p>
            <div className="mt-2 space-y-1">
              {data.sample_data.sample_exercises
                ?.slice(0, 3)
                .map((exercise: any) => (
                  <div key={exercise.id} className="text-xs text-gray-500">
                    {exercise.name} ({exercise.difficulty})
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>

      <div className="text-xs text-gray-400">
        Last checked:{' '}
        {data?.timestamp && new Date(data.timestamp).toLocaleString()}
      </div>
    </div>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="min-h-screen bg-gray-100 p-4">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-2 mb-4">
            <h1 className="text-3xl font-bold mb-4">
              Cloudflare Full-Stack App ({config.environment})
            </h1>
            {config.environment === 'staging' && (
              <span className="px-2 py-1 text-sm font-semibold bg-yellow-200 text-yellow-800 rounded-md">
                Staging Environment test
              </span>
            )}
          </div>
          <div className="bg-white rounded-lg shadow p-6">
            <HealthCheck />
          </div>
          <div className="mt-4 text-sm text-gray-500">
            Build Time: {BUILD_TIME}
          </div>
        </div>
      </div>
    </QueryClientProvider>
  );
}

export default App;
